<div class="w-full h-12rem px-4 flex align-items-center justify-content-center " style="margin: -32px 0 0 0; background: url(../../../../assets/images/header_bg1.png) no-repeat left top #000086; background-size: cover;">
  <h1 class="w-full text-center font-bold text-2xl lg:text-6xl sm:text-4xl md:text-5xl " style="color: #fff;">Admission Calendar</h1>
</div>
<div class="w-full py-6" style="background-color: #fff;">
  <div class="container_width flex flex-column gap-5">
      <div class="w-full flex align-items-center justify-content-center">
          <span class="text-center font-medium text-xl md:text-4xl" style="background-color: #CDD12A; color: #212022; padding: 8px 20px; border-radius: 16px 0 16px 16px;">United States</span>
      </div>
      <div class="w-full grid">
          <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                  <span class="w-full flex align-items-start justify-content-start ">
                    <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                  </span>
                  <b class="text-left font-medium text-xl" style="color: #212022;">November</b>
                  <p class="text-left font-normal text-base" style="color: #515055;">Early action & Early decision deadline.<br>

                    Results are declared in December.</p>
              </div>
          </div>
          <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                  <span class="w-full flex align-items-start justify-content-start ">
                    <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                  </span>
                  <b class="text-left font-medium text-xl" style="color: #212022;">January</b>
                  <p class="text-left font-normal text-base" style="color: #515055;">Regular decision deadline.<br>

                    Results are declared in March / April.</p>
              </div>
          </div>
          <div class="col-12 lg:col-4">
            <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                <span class="w-full flex align-items-start justify-content-start ">
                  <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                </span>
                <b class="text-left font-medium text-xl" style="color: #212022;">Rolling Admission</b>
                <p class="text-left font-normal text-base" style="color: #515055;">Some colleges have rolling admissions which means colleges review applications as they come in without any fixed deadline.</p>
            </div>
        </div>
      </div>
  </div>
</div>

<div class="w-full py-6" style="background-color: #F5F5FE;">
  <div class="container_width flex flex-column gap-5">
      <div class="w-full flex align-items-center justify-content-center">
          <span class="text-center font-medium text-xl md:text-4xl" style="background-color: #CDD12A; color: #212022; padding: 8px 20px; border-radius: 16px 0 16px 16px;">United Kingdom</span>
      </div>
      <div class="w-full grid">
        <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                  <span class="w-full flex align-items-start justify-content-start ">
                    <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                  </span>
                  <b class="text-left font-medium text-xl" style="color: #212022;">16 October</b>
                  <p class="text-left font-normal text-base" style="color: #515055;">Deadline for medicine, dentistry, veterinary medicine, and Oxford & Cambridge.</p>
              </div>
          </div>
          <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                  <span class="w-full flex align-items-start justify-content-start ">
                    <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                  </span>
                  <b class="text-left font-medium text-xl" style="color: #212022;">31 January</b>
                  <p class="text-left font-normal text-base" style="color: #515055;"><span class="font-medium text-base" style="color: #212022;">Main UCAS deadline</span> for most other courses. Applying by this date ensures equal consideration by universities.</p>
              </div>
          </div>
          <div class="col-12 lg:col-4">
            <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                <span class="w-full flex align-items-start justify-content-start ">
                  <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                </span>
                <b class="text-left font-medium text-xl" style="color: #212022;">30 June</b>
                <p class="text-left font-normal text-base" style="color: #515055;">Applications received after this date will be entered into <span class="font-medium text-base" style="color: #212022;">UCAS Clearing.</span></p>
            </div>
        </div>
      </div>
  </div>
</div>

<div class="w-full py-6" style="background-color: #fff;">
  <div class="container_width flex flex-column gap-5">
      <div class="w-full flex align-items-center justify-content-center">
          <span class="text-center font-medium text-xl md:text-4xl" style="background-color: #CDD12A; color: #212022; padding: 8px 20px; border-radius: 16px 0 16px 16px;">India</span>
      </div>
      <div class="w-full grid">
        <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                  <span class="w-full flex align-items-start justify-content-start ">
                    <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                  </span>
                  <b class="text-left font-medium text-xl" style="color: #212022;">Central Universities</b>
                  <p class="text-left font-normal text-base" style="color: #515055;">Application deadline: April - June <br>

                    <!-- Results are declared in December.</p> -->
              </div>
          </div>
          <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                  <span class="w-full flex align-items-start justify-content-start ">
                    <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                  </span>
                  <b class="text-left font-medium text-xl" style="color: #212022;">Private Universities</b>
                  <p class="text-left font-normal text-base" style="color: #515055;">Regular-admission round: January - April<br>

                    Late-admission round: May - June (depending on seat availability)</p>
              </div>
          </div>
          <div class="col-12 lg:col-4">
            <div class="w-full h-full bg-white p-4 flex flex-column gap-3 align-items-start border-1 border-round-lg " style="border-color: #ddd;">
                <span class="w-full flex align-items-start justify-content-start ">
                  <img src="../../../../assets/icons/deadline.svg" alt="" style="width: 48px;">
                </span>
                <b class="text-left font-medium text-xl" style="color: #212022;">National/ State Universities</b>
                <p class="text-left font-normal text-base" style="color: #515055;">Application deadline: May - June </p>
            </div>
        </div>
      </div>
  </div>
</div>

<div class="w-full py-6" style="background-color: #F5F5FE;">
  <div class="container_width flex flex-column gap-6">
      <div class="w-full flex align-items-center justify-content-center">
          <span class="text-center font-medium text-xl md:text-4xl" style="background-color: #CDD12A; color: #212022; padding: 8px 20px; border-radius: 16px 0 16px 16px;">Which intake fits you best?</span>
      </div>
      <div class="w-full grid">
        <div class="col-12 lg:col-4">
              <div class="w-full h-full bg-white p-4 flex gap-3 align-items-center border-1 border-round-lg " style="border-color: #ddd;">
                <div class="w-full flex flex-column gap-1 ">
                  <b class="text-left font-medium text-xl" style="color: #212022;">Fall Intake</b>
                  <p class="text-left font-normal text-base" style="color: #515055;">Course start September</p>
                </div>

                <img src="../../../../assets/icons/fall.png" alt="" style="width: 48px;" class="flex-shrink-0">

              </div>
          </div>
          <div class="col-12 lg:col-4">
            <div class="w-full h-full bg-white p-4 flex gap-3 align-items-center border-1 border-round-lg " style="border-color: #ddd;">
              <div class="w-full flex flex-column gap-1 ">
                <b class="text-left font-medium text-xl" style="color: #212022;">Spring Intake</b>
                <p class="text-left font-normal text-base" style="color: #515055;">Course start May</p>
              </div>

              <img src="../../../../assets/icons/spring.png" alt="" style="width: 48px;" class="flex-shrink-0">

            </div>
        </div>
        <div class="col-12 lg:col-4">
          <div class="w-full h-full bg-white p-4 flex gap-3 align-items-center border-1 border-round-lg " style="border-color: #ddd;">
            <div class="w-full flex flex-column gap-1 ">
              <b class="text-left font-medium text-xl" style="color: #212022;">Winter Intake</b>
              <p class="text-left font-normal text-base" style="color: #515055;">Course start January</p>
            </div>

            <img src="../../../../assets/icons/snow.png" alt="" style="width: 48px;" class="flex-shrink-0">

          </div>
      </div>
      </div>
      <div class="w-full flex flex-column gap-2">
          <b class="text-left font-normal text-lg " style="color: #212022;">* Graduate admissions are usually conducted on a rolling basis with results typically out within 4-6 weeks.</b>
          <b class="text-left font-normal text-lg " style="color: #212022;">* All official test scores must be submitted prior to application deadlines</b>
          <b class="text-left font-normal text-lg " style="color: #212022;">* Always email university admissions to resolve any specific doubts you might have</b>
      </div>
  </div>
</div>